<div mat-dialog-title>
    <h5 class="p-y-sm">{{ category().name || "categoryGroup.addNewCategory" | translate }}</h5>
</div>
<mat-dialog-content fxLayout="column">
    <div class="p-t-xl" fxFlex="none">
        @if (form) {
            <cipo-text [control]="form.controls.number" />
            <cipo-text [control]="form.controls.name" />
        }
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close class="m-r-md">
        {{ "general.cancel" | translate }}
    </button>
    <cipo-save-button
        [type]="SAVE_BUTTON_TYPE.SaveAndAddNew"
        [disable]="form?.invalid || !form?.dirty"
        (saveEvent)="save($event)"></cipo-save-button>
</mat-dialog-actions>
